/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { munchkinStart } from './munchkin-151';

/*
 * Copyright (c) 2007-2015, Marketo, Inc. All rights reserved.
 * Marketo marketing automation web activity tracking script
 * Version: prod r619
 */
export function munchkinProvide(b: any) {
  if (!b.Munchkin) {
    // var c = b.document,
    const e = [
    ];
    let k;
    const l = {
      fallback: '151'
    };
    const g = [
    ];
    const m = function() {
      if (!k) {
        for (; 0 < e.length; ) {
          const f = e.shift();
          b.MunchkinTracker[f[0]].apply(b.MunchkinTracker, f[1]);
        }
        k = !0;
      }
    };
    // n = function (f) {
    //   var a = c.createElement('script'),
    //   b = c.getElementsByTagName('base') [0] || c.getElementsByTagName('script') [0];
    //   a.type = 'text/javascript';
    //   a.async = !0;
    //   a.src = f;
    //   a.onreadystatechange = function () {
    //     'complete' !== this.readyState && 'loaded' !== this.readyState || m()
    //   };
    //   a.onload = m;
    //   b.parentNode.insertBefore(a, b)
    // },
    const h = {
      ASSOCIATE_LEAD: 'ASSOCIATE_LEAD',
      CLICK_LINK: 'CLICK_LINK',
      VISIT_WEB_PAGE: 'visitWebPage',
      init(b) {
        let a;
        a = l[b];
        if (!a && 0 < g.length) {
          a = b;
          let c = 0;
          let d;
          if (0 !== a.length) {for (d = 0; d < a.length; d += 1) {c += a.charCodeAt(d);}}
          a = g[c % g.length];
        }
        a || (a = l.fallback);
        e.push(['init', arguments]);
        // n('151');
      }
    };
    const p = function(b) {
      return h[b] = function() {
        e.push([b,
        arguments]);
      };
    };
    b.mktoMunchkinFunction = p('munchkinFunction');
    p('createTrackingCookie');
    b.Munchkin = h;
    b.mktoMunchkin = h.init;
    munchkinStart(b);
    m();
    b.Munchkin.init('627-OMK-391', { domainLevel: 2});
  }
};
